import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { initSentry } from '@weretradeit/sentry/react';
/**
 * Die Basis-Tokens des Design-Systems — die fehlten hier einmal vollstaendig.
 *
 * Am 2026-08-13 im gebauten Bundle gemessen: 60 fallbacklose Variablen
 * benutzt, 21 definiert — 43 undefiniert, weil das Paket nicht einmal als
 * Abhaengigkeit stand. Betroffen war jede Farbe, jeder Abstand, jeder Radius,
 * jede Schriftgroesse; sogar index.html setzt `background: var(--bg)` auf
 * <body>. Die Anwendung rendert dann als schwarzer Text auf weiss. Diese
 * Zeile MUSS ueber `./App` und `./styles.css` stehen.
 *
 * `@weretradeit/ui-react/src/styles.css` ist mit 3.x ersatzlos entfallen: das
 * Paket liefert ueberhaupt kein CSS mehr aus — weder `src/styles.css` noch
 * `dist/index.css` existieren darin — und die Bauteile stylen inline und ueber
 * die Klassen des Design-Systems. Der Pfad ging ohnehin am Paketvertrag
 * vorbei: er griff in `src/` hinein, ein Verzeichnis, das 3.x nicht
 * ausliefert. Waere die Zeile stehengeblieben, haette der Bau sie als
 * fehlendes Modul gemeldet.
 */
import '@weretradeit/design-system/v3/base-clean.css';
/* 4.2.1: die Szene dieser App fuer GlyphLoader, GlyphErrorPage und die
   ErrorBoundary steht BEWUSST NICHT hier (Flottenregel seit 09.10.2026). Ein
   statischer Import an dieser Stelle liess die Engine schon im ersten
   Wartebild (`hydrateFallbackElement`) zeichnen, und sie nahm der App den
   Hauptthread, bevor die Huelle stand (accountingFox PR 790, CI-E2E rot). Sie
   laedt jetzt App.tsx beim Einhaengen, im Leerlauf — Begruendung in
   glyphScene.ts. Exakt 4.2.1 bleibt: 4.2.0 fuehrte `wt-glyphfield*.js` nicht
   in `sideEffects`, und Vite warf den Szenen-Import still heraus. */
import { routes } from './routes';
import './styles.css';

// Initialize Sentry error tracking
initSentry({ appName: 'marketShark' });

/**
 * Der Baum steht in `routes.tsx`, nicht hier.
 *
 * Hier stand er frueher — und zwar mit genau EINER Route (`/` -> App). Vierzehn
 * Seiten unter `src/pages/` waren dadurch unerreichbar, und `App.test.tsx`
 * baute sich fuer seine Faelle einen ZWEITEN Baum, der andere Pfade kannte als
 * die Anwendung. Beide Beschreibungen konnten nicht gleichzeitig stimmen, und
 * die des Tests war die falsche.
 *
 * Jetzt teilen sich Anwendung und Test dieselbe Quelle.
 */
const router = createBrowserRouter(routes);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
